import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { apiUrl } from "../consts/consts";
import MainPage from "./MainPage";

function RequireAuth() {
  const navigate = useNavigate();
  const token = localStorage.getItem("Impact");
  const [user, setUser] = useState("");

  async function validateUser() {
    try {
      const response = await axios.get(`${apiUrl}/user`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser(response.data.user);

      if(!response.data.user){
        navigate("/login");
      } else {
        if(window.location.pathname === '/'){
          navigate("/publishers");
        }
      }
    } catch (error) {
      localStorage.removeItem("Impact");
      navigate("/login");
    }
  }

  useEffect(() => {
    validateUser();
  }, []);


  return (
    <>
      { user && <MainPage user={user} />}
    </>
  );
}

export default RequireAuth;
